import { createContext, useContext } from 'react';

// Opens the global contact modal owned by Layout. Pages call
// useContactModal()() instead of reaching for a window global.
const ContactModalContext = createContext<() => void>(() => {
  console.warn('useContactModal called outside ContactModalProvider');
});

export const ContactModalProvider = ContactModalContext.Provider;

export const useContactModal = () => useContext(ContactModalContext);
